import { UserData } from "src/app/dto/user-data";
import { ServiceResponse } from "../ServiceResponse";

export class UserInfoResponse extends ServiceResponse {
  public UserInfo: UserData | null = null;
}
